import { Action } from 'redux';

import {
    APIFailureAction,
    APIRequestAction,
    APISuccessAction,
} from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';
import { PageHeaderUserData } from 'mk2/schemas';

/////////////////////////////////////////////////////////////////////
// Fetch flagged counts

export const PAGEHEADER_FETCH_FLAGGED_COUNTS_TRIGGER = 'PAGEHEADER_FETCH_FLAGGED_COUNTS_TRIGGER';
export interface PageHeaderFetchFlaggedCountsTriggerAction {
    readonly type: typeof PAGEHEADER_FETCH_FLAGGED_COUNTS_TRIGGER;
}
export const PAGEHEADER_FETCH_FLAGGED_COUNTS_REQUEST = 'PAGEHEADER_FETCH_FLAGGED_COUNTS_REQUEST';
export interface PageHeaderFetchFlaggedCountsRequestAction extends APIRequestAction {
    readonly type: typeof PAGEHEADER_FETCH_FLAGGED_COUNTS_REQUEST;
}
export const PAGEHEADER_FETCH_FLAGGED_COUNTS_SUCCESS = 'PAGEHEADER_FETCH_FLAGGED_COUNTS_SUCCESS';
export interface PageHeaderFetchFlaggedCountsSuccessAction extends APISuccessAction {
    readonly type: typeof PAGEHEADER_FETCH_FLAGGED_COUNTS_SUCCESS;
    readonly flaggedCount: number;
    readonly flaggedGroupCount: number;
}
export const PAGEHEADER_FETCH_FLAGGED_COUNTS_FAILURE = 'PAGEHEADER_FETCH_FLAGGED_COUNTS_FAILURE';
export interface PageHeaderFetchFlaggedCountsFailureAction extends APIFailureAction {
    readonly type: typeof PAGEHEADER_FETCH_FLAGGED_COUNTS_FAILURE;
}

export const pageHeaderFetchFlaggedCountsTrigger =
    (): PageHeaderFetchFlaggedCountsTriggerAction => ({
        type: PAGEHEADER_FETCH_FLAGGED_COUNTS_TRIGGER,
    });
export const pageHeaderFetchFlaggedCountsApi = {
    request: (): PageHeaderFetchFlaggedCountsRequestAction => ({
        type: PAGEHEADER_FETCH_FLAGGED_COUNTS_REQUEST,
    }),
    success: (flaggedCount: number, flaggedGroupCount: number, response: any): PageHeaderFetchFlaggedCountsSuccessAction => ({
        type: PAGEHEADER_FETCH_FLAGGED_COUNTS_SUCCESS, flaggedCount, flaggedGroupCount, response,
    }),
    failure: (error: any): PageHeaderFetchFlaggedCountsFailureAction => ({
        type: PAGEHEADER_FETCH_FLAGGED_COUNTS_FAILURE, error,
    }),
};

///////////////////////////////////////////////////////////////////
// Progress broadcast

export interface PageHeaderFetchAction extends Action {
}
export const PAGEHEADER_FETCH_REQUEST = 'PAGEHEADER_FETCH_REQUEST';
export interface PageHeaderFetchRequestAction extends PageHeaderFetchAction, APIRequestAction {
    readonly type: typeof PAGEHEADER_FETCH_REQUEST;
}
export const PAGEHEADER_FETCH_SUCCESS = 'PAGEHEADER_FETCH_SUCCESS';
export interface PageHeaderFetchSuccessAction extends PageHeaderFetchAction, APISuccessAction {
    readonly type: typeof PAGEHEADER_FETCH_SUCCESS;
    readonly data: PageHeaderUserData;
}
export const PAGEHEADER_FETCH_FAILURE = 'PAGEHEADER_FETCH_FAILURE';
export interface PageHeaderFetchFailureAction extends PageHeaderFetchAction, APIFailureAction {
    readonly type: typeof PAGEHEADER_FETCH_FAILURE;
}

export const pageHeaderFetch = {
    request: (): PageHeaderFetchRequestAction => ({
        type: PAGEHEADER_FETCH_REQUEST,
    }),
    success: (data: PageHeaderUserData): PageHeaderFetchSuccessAction => ({
        type: PAGEHEADER_FETCH_SUCCESS,
        data,
        response: null,
    }),
    failure: (error: any): PageHeaderFetchFailureAction => ({
        type: PAGEHEADER_FETCH_FAILURE, error,
    }),
};

///////////////////////////////////////////////////////////////////
// Triggers

// PageHeader load
export const PAGEHEADER_LOAD = 'PAGEHEADER_LOAD';
export interface PageHeaderLoadAction extends PageHeaderFetchAction {
    readonly type: typeof PAGEHEADER_LOAD;
}
export const pageHeaderLoad = (): PageHeaderLoadAction => ({
    type: PAGEHEADER_LOAD,
});
